module.exports = __webpack_public_path__ + "images/common/estimate_times_f82ab6509fb650a07ef1af65c752152d.svg";